export const LANGUAGES = [
  {
    language:"english",
    languageShort:"en"
  },
  {
    language:"shqip",
    languageShort:"sq"
  },
  {
    language:"македонски",
    languageShort:"mk"
  }
]